import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeScheduledReportEnqueueResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof BackofficeScheduledReportEnqueueResponseDataSchema>>

export function useEnqueueBackofficeScheduledReportsMutation() {
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await axios.post<Response>(`/backoffice/scheduledReports/${id}/test`)

      return response.data
    },
  })
}
